import { Close } from "@mui/icons-material"
import { Dialog, type DialogProps, IconButton } from "@mui/material"

type Props = DialogProps & {
  close: () => void
}

export function Root({ open, close, children, sx, ...rest }: Props) {
  return (
    <Dialog
      open={open}
      onClose={close}
      fullWidth
      maxWidth={"md"}
      slotProps={{
        paper: {
          sx: {
            overflowY: "hidden",
          },
        },
      }}
      sx={sx}
      {...rest}
    >
      <IconButton
        aria-label="close"
        size="small"
        sx={{ position: "absolute", right: 8, top: 8, zIndex: 1 }}
        onClick={close}
      >
        <Close fontSize="small" />
      </IconButton>

      {children}
    </Dialog>
  )
}
